<template>
	<div>
		<DefaultWidgetField v-bind="defaultFieldProps" v-on="defaultFieldListeners" :hideTitle="hideTitle" />
		<p :ref="fieldRef" v-html="cleanHtml" class="paragraph" />
	</div>
</template>
<script>
import { sanitizeHtml } from '@/utils/helpers';

import { escapeNonValidHTMLTags } from '@/utils/helpers';

import WidgetFieldMixin from './WidgetFieldMixin';

import DefaultWidgetField from './DefaultWidgetField';

export default {
	name: 'TextOutputField',
	components: { DefaultWidgetField },
	mixins: [WidgetFieldMixin],
	computed: {
		encodedContent() {
			return escapeNonValidHTMLTags(this.value);
		},
		cleanHtml() {
			return sanitizeHtml(this.encodedContent);
		},
		hideTitle() {
			// HACK: 8.2.2022 this is a hack to support old TextOutputField.
			// we enabled title while old configurations were already enabled (but without DefaultWidgetField which displays it)
			// old values are '' or 'Text Output label' so we hack this by excluding them
			// remove this in a while :)
			return ['', null, undefined, 'Text Output label'].includes(this.titleValueLocal);
		},
	},
};
</script>

<style scoped lang="scss">
.paragraph {
	padding-top: 6px !important;
	padding-bottom: 6px !important;
	margin-bottom: 16px !important;

	::v-deep {
		$line-height: 1.5em;
		p {
			line-height: $line-height;
			min-height: $line-height; // Fix for 'empty paragraphs (<p></p>) has height === 0' bug
			font-size: 15px;
			white-space: pre-wrap;
			word-break: break-word;
			font-weight: 400;
			color: #303133;
			letter-spacing: -0.05px;
		}
		img {
			max-width: 100%;
		}
	}
}
</style>
